// Valores de exemplo para mostrar um modelo de mensagem já preenchido,
// sem as variáveis entre chaves ({name}, {when}...). Usado no resumo do
// card e no preview completo de Modelos > Mensagens.
const EXAMPLE_VALUES = {
    '{name}': 'João Silva',
    '{day}': '15',
    '{month}': 'Janeiro',
    '{when}': 'Segunda-feira',
    '{time}': '14:30',
    '{appointment_date}': '15/01',
    '{price_pix}': '150,00',
    '{price_card}': '160,00',
    '{address}': 'Rua das Flores, 123 - Centro',
    '{professional_name}': 'Maria Santos',
    '{procedure_name}': 'Avaliação Inicial',
    '{company_name}': 'Empresa Exemplo',
    '{company_phone}': '(11) 99999-0000',
    '{patient_name}': 'João da Silva Santos',
    '{company_policies}': 'Cancelamentos com 24h de antecedência',
    '{greetings}': 'Olá',
    '{deadline}': 'hoje, às 15:30'
};

const fillTemplateExample = (content) => {
    if (!content) return '';

    let filled = content;
    Object.entries(EXAMPLE_VALUES).forEach(([variable, value]) => {
        filled = filled.replaceAll(variable, value);
    });
    return filled;
};

export default fillTemplateExample;
